<template>
    <div>
        <KanbanView />
    </div>
</template>

<script setup>
import MainLayout from "@/layouts/MainLayout.vue";
defineOptions({ layout: MainLayout });
import KanbanView from "./Presupuestos/components/KanbanView.vue";
</script>

<style lang="scss" scoped>

</style>
